/**
 * OpenTicketsQueue — grid of live open tickets with age and item preview.
 */
import React from 'react';
import { fmt$ } from '../../../../utils/formatUtils';
import { minutesAgo } from '../../squareDashboardUtils';

export default function OpenTicketsQueue({ openOrders, staleMinutes }) {
  if (!openOrders || openOrders.length === 0) return null;
  return (
    <div className="ai__section">
      <div className="ai__section-title">🎫 Live Open Tickets ({openOrders.length})</div>
      <div className="ai__queue-grid">
        {openOrders.slice(0, 20).map(o => {
          const opened = o.createdAt ? new Date(o.createdAt).getTime() : 0;
          const mins = opened ? minutesAgo(opened) : null;
          const isStale = mins !== null && mins >= staleMinutes;
          return (
            <div key={o.id} className={`ai__queue-card ${isStale ? 'ai__queue-card--stale' : ''}`}>
              <div className="ai__queue-name">{o.ticketName || o.shortId || '—'}</div>
              <div className="ai__queue-meta">
                {mins !== null && <span className={`ai__queue-age ${isStale ? 'ai__queue-age--stale' : ''}`}>{mins}m</span>}
                <span className="ai__queue-amt">{o.total ? fmt$(o.total) : ''}</span>
              </div>
              {o.items?.length > 0 && (
                <div className="ai__queue-items">
                  {o.items.slice(0, 2).map((it, j) => (
                    <span key={j} className="ai__queue-item">{it.qty}× {it.name}</span>
                  ))}
                  {o.items.length > 2 && <span className="ai__queue-more">+{o.items.length - 2}</span>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
